import { SessionContextDto } from '../contexts/dtos/SessionContextDto';

export const sessionReducer = (state: SessionContextDto, action: SessionReducerType) => {
  let newState;
  switch (action.type) {
    case SessionReducerActionOptions.Change:
      newState = new SessionContextDto();
      Object.assign(newState, action.session);
      return newState;
    case SessionReducerActionOptions.Reset:
      newState = new SessionContextDto();
      return newState;

    default:
      return state;
  }
};

export class SessionReducerActionOptions {
  static Change = 'Change';
  static Reset = 'Reset';
}

export interface SessionReducerType {
  type: SessionReducerActionOptions;
  session: SessionContextDto | null;
}
